import { Button } from 'antd';
import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import WOW from 'wowjs';
import { moneda } from '../../../helper';

import './mercadoPublico.css'

const CardMercado = ({ vehiculo }) => {

    useEffect(() => {
        new WOW.WOW({
            live: false
        }).init();
    }, []);

    if (!vehiculo) return null;

    return (
        <>
            <Col className="wow fadeIn px-1 pb-1 border-c-merc d-none d-md-block" xs={12} sm={6} md={6} lg={6} xl={3}>
                <Container className="bg-white card-mercado h-100" fluid>
                    <Row>
                        <Col xs={12} className="mt-3">
                            <h5 className="bold-title-hyundai mb-1 f-responsive-14">{vehiculo.Nombre}</h5>
                            <p className="parrafo-hyundai f-responsive">{vehiculo.descripcionCorta}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={11} lg={10} className="text-center border-mercado mx-auto">
                            <p className="my-2 parrafo-hyundai f-responsive">ID:{vehiculo.idMercadopublico}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} className="mx-auto text-center">
                            <img src={vehiculo.Imagen} alt={vehiculo.Nombre} className="img-fluid img-preview" />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} className="text-center mb-3 mt-3">
                            <h5 className="bold-title-hyundai font-precio f-responsive-14">{moneda(vehiculo.tipoMoneda)}{vehiculo.Precio.toLocaleString('es-CL')} <span className="iva">+IVA</span></h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} lg={8} className="mx-auto mb-2">
                            <Link to={`/cotizar/mercado-publico/${vehiculo.Slug}`}>
                                <Button className="w-100 font-btn btn-primario f-responsive-14">Cotizar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} lg={8} className="mx-auto mb-2">
                            <Link to={`/mercado-publico/${vehiculo.Slug}`}>
                                <Button className="w-100 font-btn btn-secundario f-responsive-14">Ver ficha</Button>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </Col>
            <Col className="wow fadeIn px-1 pb-1 border-bottom-merc d-block d-md-none" xs={12} sm={6} md={6} lg={6} xl={3}>
                <Container className="bg-white card-mercado h-100" fluid>
                    <Row>
                        <Col xs={4} className="mx-auto my-auto pr-0 text-center">
                            <img src={vehiculo.Imagen} alt={vehiculo.Nombre} className="img-fluid" />
                        </Col>
                        <Col xs={8} className="mt-3">
                            <Row>
                                <Col xs={12}>
                                    <h5 className="bold-title-hyundai mb-0 f-responsive-14">{vehiculo.Nombre}</h5>
                                    <p className="parrafo-hyundai mb-1 f-responsive-10">{vehiculo.descripcionCorta}</p>
                                </Col>
                            </Row>
                            <Row className="px-3">
                                <Col xs={12} className="border-mercado mx-auto px-0">
                                    <p className="my-1 parrafo-hyundai f-responsive-10">ID:{vehiculo.idMercadopublico}</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} className="my-2">
                                    <h5 className="bold-title-hyundai mb-0 mt-1 font-precio f-responsive">{moneda(vehiculo.tipoMoneda)}{vehiculo.Precio.toLocaleString('es-CL')} <span className="iva">+IVA</span></h5>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col xs={6} className="mx-auto pr-4">
                                    <Link to={`/cotizar/mercado-publico/${vehiculo.Slug}`}>
                                        <Button className="w-100 font-btn btn-primario">Cotizar</Button>
                                    </Link>
                                </Col>
                                <Col xs={6} className="mx-auto pr-4">
                                    <Link to={`/mercado-publico/${vehiculo.Slug}`}>
                                        <Button className="w-100 font-btn btn-secundario">Ver ficha</Button>
                                    </Link>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Col>
        </>
    );
}

export default CardMercado;